export default "__VITE_ASSET__D$O1RBeH__"